import React, { useCallback } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { PlusIcon } from '@vlabs/icons';
import { permissions } from '@vlabs/shared/config';
import { useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';

import { FaceCreateForm } from './forms/FaceCreateForm';
import type { CreateFaceProps, Card } from './types';

export function CreateCardFace({
  title,
  defaultValues,
  formFieldComponent,
  onSuccess,
  context = undefined,
  // FIXME: выкинуть эту шляпу, задача https://jira.visionlabs.ru/browse/GUI-3390
  noSelect = false,
}: CreateFaceProps): React.JSX.Element {
  const { t } = useTranslation();
  const modal = useModal();

  const submitForm = useCallback(async (values: Card) => {
    await apiContainer.lunaClient.faces.create(values, { extract_basic_attributes: 1 });
    onSuccess?.();
    modal.close();
    toast.success(t('monokit:create face modal.toast.face create success'));
  }, [onSuccess, modal, t]);

  return (
    <React.Fragment>
      {modal.wrap(<FaceCreateForm
        closeModal={modal.close}
        context={context}
        defaultValues={defaultValues}
        formFieldComponent={formFieldComponent}
        noSelect={noSelect}
        onSubmit={submitForm}
      />)}
      <ButtonWithPermissions
        data-testid="createFaceButton"
        icon={<PlusIcon />}
        onClick={modal.open}
        permissions={{
          rules: [
            permissions.face.creation,
            permissions.resources.sdk,
            permissions.faceSample.creation,
            permissions.attribute.creation,
          ],
          method: 'allof',
        }}
        title={title ?? t('monokit:create face modal.forms.buttons.create face')}
      >
        {title ?? t('monokit:create face modal.forms.buttons.create face')}
      </ButtonWithPermissions>
    </React.Fragment>
  );
}
